import script from "./AppStartModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AppStartModal.vue?vue&type=script&setup=true&lang=js"

import "./AppStartModal.vue?vue&type=style&index=0&id=0889b975&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0889b975"]])

export default __exports__